import { DynamicContextProvider as DynamicContextProvider$1 } from '@dynamic-labs/sdk-react-core';
export * from '@dynamic-labs/sdk-react-core';
import { EthereumWalletConnectors } from '@dynamic-labs/ethereum-all';
import { AlgorandWalletConnectors } from '@dynamic-labs/algorand-all';
import { SolanaWalletConnectors } from '@dynamic-labs/solana-all';
import { FlowWalletConnectors } from '@dynamic-labs/flow-all';
import { StarknetWalletConnectors } from '@dynamic-labs/starknet-all';
import { MagicWalletConnectors } from '@dynamic-labs/magic';
import { CosmosWalletConnectors } from '@dynamic-labs/cosmos-all';

/* eslint-disable import/export */
const DynamicContextProvider = (props) => {
    if (!props.settings.walletConnectors) {
        props.settings.walletConnectors = [
            EthereumWalletConnectors,
            AlgorandWalletConnectors,
            SolanaWalletConnectors,
            FlowWalletConnectors,
            StarknetWalletConnectors,
            MagicWalletConnectors,
            CosmosWalletConnectors,
        ];
    }
    return DynamicContextProvider$1(props);
};

export { DynamicContextProvider };
